import React from 'react'
import { isEmpty } from 'lodash'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import { deepOrange500, lightGreenA700 } from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ServiceCategoryForm from './ServiceCategoryForm'

import Resource from '../../stores/resource'
const CategoryStore = Resource('service-categories')

class EditServiceCategory extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      serviceCategory: this.props.serviceCategory || {},
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = attributes => {
    CategoryStore.update(this.state.serviceCategory.id, attributes)
      .then(result => {
        this.setState(
          {
            saved: true,
            changed: false,
            error: '',
            savedServiceCategory: result.data.data,
            snackbarMessage: `ServiceCategory "${attributes.name}" saved!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedServiceCategory)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _changed = didChange => this.setState({ changed: didChange, saved: false })

  _closeErrorDialog = () => this.setState({ error: '' })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const { redirect, changed, saved, snackbarMessage, error } = this.state

    if (redirect) return <Redirect push to={redirect} />

    const serviceCategory = isEmpty(this.state.serviceCategory)
      ? null
      : this.state.serviceCategory

    const name = serviceCategory.attributes
      ? serviceCategory.attributes.name
      : ''

    return (
      <section>
        <ServiceCategoryForm
          formTitle={
            <span>
              {name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500} />}
              {saved && <ActionCheckCircle color={lightGreenA700} />}
            </span>
          }
          serviceCategory={serviceCategory}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo('/service-categories')}
        />

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes"
        >
          <p>
            The service category <strong>{name}</strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditServiceCategory



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/EditServiceCategory.jsx